import { jsx as _jsx } from "react/jsx-runtime";
import LoyaltyLogo from "../../icons/loyalty_logo.svg";
export const PointsBlockLogo = ({ hasLogo }) => {
    if (!hasLogo) {
        return null;
    }
    return (_jsx("div", { className: "points-block__logo", children: _jsx(LoyaltyLogo, { width: "56px", height: "34px" }) }));
};
//# sourceMappingURL=PointsBlockLogo.js.map